var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('div',{staticClass:"slido-wrap",class:[{ 'slido-mobile': _vm.isMobile }, _vm.itemClass]},[_c('iframe',{attrs:{"src":_vm.link,"frameborder":"0"}}),_vm._v(" "+_vm._s(_vm.itemClass)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }